module.exports = __webpack_public_path__ + "img/news2-1.f69339ea.png";